var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active && _vm.headline && _vm.text)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"mb",domProps:{"innerHTML":_vm._s(_vm.headline)}}),_c('div',{staticClass:"mb",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"btn",on:{"click":function($event){_vm.active = false;
      _vm.headline = null;
      _vm.text = null;
      _vm.$router.go();}}},[_vm._v(" OK ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }